import type { SVGProps } from "react";

const SvgRbLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 46.08 46.08"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
    }}
    {...props}
  >
    <clipPath id="a">
      <path d="M0 0h46.08v46.08H0z" />
    </clipPath>
    <g clipPath="url(#a)">
      <path
        style={{
          fill: "#fff200",
        }}
        transform="scale(1.92)"
        d="M0 0h24v24H0z"
      />
      <path d="m7.69 33.42 4.542 4.628 10.64-10.797 11 11.02 4.607-4.563L27.591 22.82l2.094-2.025v-4.319l1.313-1.112v3.382l1.693 1.38 5.052-5.053 1.626 1.246c.957-3.538-4.587-11.576-9.172-7.123l-5.344 5.299 1.092 1.313-2.716 2.648-2.628-2.581 1.38-1.247-5.855-5.655c-4.407-3.63-8.927 1.893-9.082 7.28l1.603-1.335 4.919 5.299 1.759-1.47v-3.25l1.09.822v4.254l2.137 2.137z" />
    </g>
  </svg>
);
export default SvgRbLogo;
